import { webatlasTileLayer, WebatlasTileLayerTypes } from 'leaflet-webatlastile';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import 'slick-carousel';
import "leaflet-fullscreen";

function cloneOptions(options) {
  var ret = {};
  for (var i in options) {
    var item = options[i];
    if (item && item.clone) {
      ret[i] = item.clone();
    } else if (item instanceof L.Layer) {
      ret[i] = cloneLayer(item);
    } else {
      ret[i] = item;
    }
  }
  return ret;
}

function cloneInnerLayers(layer) {
  var layers = [];
  layer.eachLayer(function (inner) {
    layers.push(cloneLayer(inner));
  });
  return layers;
}

function cloneLayer(layer) {
  var options = cloneOptions(layer.options);

  // we need to test for the most specific class first, i.e.
  // Circle before CircleMarker

  // Renderers
  if (layer instanceof L.SVG) {
    return L.svg(options);
  }
  if (layer instanceof L.Canvas) {
    return L.canvas(options);
  }

  // Tile layers
  if (layer instanceof L.TileLayer.WMS) {
    return L.tileLayer.wms(layer._url, options);
  }
  if (layer instanceof L.TileLayer) {
    return L.tileLayer(layer._url, options);
  }
  if (layer instanceof L.ImageOverlay) {
    return L.imageOverlay(layer._url, layer._bounds, options);
  }

  // Marker layers
  if (layer instanceof L.Marker) {
    return L.marker(layer.getLatLng(), options);
  }

  if (layer instanceof L.Circle) {
    return L.circle(layer.getLatLng(), layer.getRadius(), options);
  }
  if (layer instanceof L.CircleMarker) {
    return L.circleMarker(layer.getLatLng(), options);
  }

  if (layer instanceof L.Rectangle) {
    return L.rectangle(layer.getBounds(), options);
  }
  if (layer instanceof L.Polygon) {
    return L.polygon(layer.getLatLngs(), options);
  }
  if (layer instanceof L.Polyline) {
    return L.polyline(layer.getLatLngs(), options);
  }

  if (layer instanceof L.GeoJSON) {
    return L.geoJson(layer.toGeoJSON(), options);
  }

  if (layer instanceof L.LayerGroup) {
    return L.layerGroup(cloneInnerLayers(layer));
  }
  if (layer instanceof L.FeatureGroup) {
    return L.FeatureGroup(cloneInnerLayers(layer));
  }

  throw 'Unknown layer, cannot clone this layer. Leaflet-version: ' + L.version;
}

if (typeof exports === 'object') {
  module.exports = cloneLayer;
}

var RouteMaps;
(function (RouteMaps) {

  var Carousel;
  (function (Carousel) {

    function initCarousel(container) {

      $(container).children(".slides").slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true
      });

    }
    Carousel.initCarousel = initCarousel;

  })(Carousel = RouteMaps.Carousel || (RouteMaps.Carousel = {}));

  var Sliders;
  (function (Sliders) {

    function calc_length(input) {
      var meters = $(input).val();
      var text = skTranslate["/routecollectionpage"]["/max"] + " " + metersToReadable(meters);

      $(input).parents(".slider-wrapper").children("label.selected").html(text);
    }
    function calc_max_length(input) {
      var meters = $(input).attr("max");
      var text = metersToReadable(meters);
      $(input).parents(".slider-wrapper").find("label.max").html(text);
    }

    function metersToReadable(value) {
      if (value < 1000) {
        return value + " meter";
      } else {
        return (value / 1000) + " km";
      }
    }

    function calc_duration(input) {
      var minutes = $(input).val();
      var text = skTranslate["/routecollectionpage"]["/max"] + " " + minutesToReadable(minutes);
      $(input).parents(".slider-wrapper").children("label.selected").html(text);
    }
    function calc_max_duration(input) {
      var minutes = $(input).attr("max");
      var text;
      text = minutesToReadable(minutes);
      $(input).parents(".slider-wrapper").find("label.max").html(text);
    }

    function minutesToReadable(value) {
      var hours = Math.floor(value / 60);
      var minutes = value % 60;

      var tAnd = skTranslate["/routecollectionpage"]["/and"];
      var tMinute = skTranslate["/routecollectionpage"]["/minute"];
      var tMinutes = skTranslate["/routecollectionpage"]["/minutes"];
      var tHour = skTranslate["/routecollectionpage"]["/hour"];
      var tHours = skTranslate["/routecollectionpage"]["/hours"];

      if (hours == 0 && minutes == 1) {
        return minutes + " " + tMinute;
      } else if (hours == 0) {
        return minutes + " " + tMinutes;
      } else if (hours == 1 && minutes == 0) {
        return hours + " " + tHour;
      } else if (minutes == 0) {
        return hours + " " + tHours;
      } else if (hours == 1 && minutes == 1) {
        return hours + " " + tHour + " " + tAnd + " " + minutes + " " + tMinute;
      } else if (hours == 1) {
        return hours + " " + tHour + " " + tAnd + " " + minutes + " " + tMinutes;
      } else if (minutes == 1) {
        return hours + " " + tHours + " " + tAnd + " " + minutes + " " + tMinute;
      } else {
        return hours + " " + tHours + " " + tAnd + " " + minutes + " " + tMinutes;
      }
    }

    function init() {
      // Initialize sliders
      $(document).on('input', '#duration_slider', function () {
        calc_duration(this);
      });
      $("#duration_slider").change(function () {
        calc_duration(this);
      });
      $(document).on('input', '#length_slider', function () {
        calc_length(this);
      });
      $("#length_slider").change(function () {
        calc_length(this);
      });

      calc_length($("#length_slider"));
      calc_max_length($("#length_slider"));

      calc_duration($("#duration_slider"));
      calc_max_duration($("#duration_slider"));
    }
    Sliders.init = init;

  })(Sliders = RouteMaps.Sliders || (RouteMaps.Sliders = {}));

  var Map;
  (function (Map) {

    var map;
    var bounds;
    var markers = L.markerClusterGroup();
    var commonGeoJsonLayer;
    var tripLayers = [];

    var iconSize = [28, 35];
    var iconAnchor = [14, 35];

    var shadowSize = [46, 42];
    var shadowAnchor = [10, 36];

    var tooltipAnchor = [14, -21];
    var popupAnchor = [0, -35];

    var tripIconEasy = L.icon({
      iconUrl: '/Static/gfx/trip_easy.png',
      shadowUrl: '/Static/gfx/trip_shadow.png',
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor,
      tooltipAnchor: tooltipAnchor,
      popupAnchor: popupAnchor
    });
    var tripIconMedium = L.icon({
      iconUrl: '/Static/gfx/trip_medium.png',
      shadowUrl: '/Static/gfx/trip_shadow.png',
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor,
      tooltipAnchor: tooltipAnchor,
      popupAnchor: popupAnchor
    });
    var tripIconDifficult = L.icon({
      iconUrl: '/Static/gfx/trip_difficult.png',
      shadowUrl: '/Static/gfx/trip_shadow.png',
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor,
      tooltipAnchor: tooltipAnchor,
      popupAnchor: popupAnchor
    });
    var tripIconExtreme = L.icon({
      iconUrl: '/Static/gfx/trip_extreme.png',
      shadowUrl: '/Static/gfx/trip_shadow.png',
      iconSize: iconSize,
      iconAnchor: iconAnchor,
      shadowSize: shadowSize,
      shadowAnchor: shadowAnchor,
      tooltipAnchor: tooltipAnchor,
      popupAnchor: popupAnchor
    });

    function initMap(container) {

      var latitude = 58.902972;
      var longitude = 5.735840;
      var zoom = 14;

      // Create a map
      bounds = new L.latLngBounds();
      map = L.map(
          container, { fullscreenControl: true }
      ).setView([latitude, longitude], zoom);

      var apiKey = 'B452657B-C6E9-42F0-BCF6-0AB37935A0CC';

      var baseLayers = {
        'Kart': webatlasTileLayer({
          mapType: WebatlasTileLayerTypes.VECTOR,
          apiKey: apiKey
        }),
        'Foto': webatlasTileLayer({
          mapType: WebatlasTileLayerTypes.AERIAL,
          apiKey: apiKey
        }),
        'Hybrid': webatlasTileLayer({
          mapType: WebatlasTileLayerTypes.HYBRID,
          apiKey: apiKey
        }),
        'OpenStreetMap': L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '© <a href="https://openstreetmap.org">OpenStreetMap</a> contributors'
        }),
      };
      
      baseLayers[Object.keys(baseLayers)[0]].addTo(map);
      
      L.control.layers(baseLayers).addTo(map);

      var currentPosition;

      var cssIcon = L.divIcon({
        className: 'css-icon',
        html: '<div class="gps_ring"></div><div class="gps_dot"></div>'
        , iconSize: [22, 22]
      });
      function onLocationFound(e) {
        if (currentPosition) {
          map.removeLayer(currentPosition);
        }
        currentPosition = L.marker(e.latlng, { icon: cssIcon }).addTo(map);
      }

      function onLocationError(e) {
        console.log(e.message);
      }

      map.on("locationfound", onLocationFound);
      map.on("locationerror", onLocationError);

      map.locate({
        watch: true,
        locate: true,
        setView: false,
        enableHighAccuracy: true
      });

      Map.map = map;
    }
    Map.initMap = initMap;

    var geoJsonLayerGroup = undefined;
    var geoJsonLayerOpacity = 0.8;
    var setupGeoJsonLayer = function (data) {

      geoJsonLayerGroup = L.geoJSON(data,
          {
            style:
                {
                  weight: 4,
                  color: "#005692",
                  opacity: geoJsonLayerOpacity
                }
          });

      geoJsonLayerGroup.addTo(map);
    }

    var adjustMapBounds = function () {
      bounds.extend(geoJsonLayerGroup.getBounds());
      map.fitBounds(bounds);
      RouteMaps.updateExportPdfUrl();
    }

    var addGeoJsonObject = function (data) {

      if (data) cachedGeoJsonData = data;

      setupGeoJsonLayer(cachedGeoJsonData)

      geoJsonLayerGroup.eachLayer(function (layer) {
        if (layer.feature.properties) {
          // Se etter snarveier
          if (layer.feature.properties["FOTRUTEINFO.RUTETYPE"] && layer.feature.properties["FOTRUTEINFO.RUTETYPE"] === "3") {
            layer.setStyle({
              opacity: geoJsonLayerOpacity,
              dashArray: "3 10",
              color: "#8E35EF",
              weight: 4
            });

          } else if (layer.feature.properties.BELYSNING) {
            if (layer.feature.properties.BELYSNING) {

              var layerForeground = cloneLayer(layer);
              layerForeground.setStyle({
                color: "#ffff00",
                opacity: geoJsonLayerOpacity,
                dashArray: "5 10",
                weight: 4
              });

              geoJsonLayerGroup.addLayer(layerForeground);

            }
          }
        }
      })
      adjustMapBounds();
    }
    Map.addGeoJsonObject = addGeoJsonObject;

    var cachedGeoJsonData = undefined;
    function addGeoJson(url) {
      Map.property = undefined;

      if (cachedGeoJsonData != undefined) {
        geoJsonLayerGroup.remove();
        Map.addGeoJsonObject()
      } else {
        $.getJSON(url, Map.addGeoJsonObject);
      }
    }
    Map.addGeoJson = addGeoJson;

    var addGeoJsonAccessibilityObject = function (data) {

      if (data) cachedAccessibilityData = data;

      var accessibilityLayer = Map.property;

      setupGeoJsonLayer(cachedAccessibilityData)
      geoJsonLayerGroup.eachLayer(function (layer) {
        if (layer.feature.properties && layer.feature.properties[accessibilityLayer]) {
          if (layer.feature.properties[accessibilityLayer] === "Tilgjengelig") {
            layer.setStyle({
              opacity: geoJsonLayerOpacity,
              color: "green",
              weight: 4
            });
          }
          else if (layer.feature.properties[accessibilityLayer] === "Delvis tilgjengelig") {
            layer.setStyle({
              opacity: geoJsonLayerOpacity,
              color: "orange",
              weight: 4
            });
          }
          else if (layer.feature.properties[accessibilityLayer] === "Ikke tilgjengelig") {
            layer.setStyle({
              opacity: geoJsonLayerOpacity,
              color: "red",
              weight: 4
            });
          }
          else if (layer.feature.properties[accessibilityLayer] === "Ikke vurdert") {
            layer.setStyle({
              opacity: geoJsonLayerOpacity,
              color: "turquoise",
              weight: 4
            });
          }
        }
      })
      adjustMapBounds();
    }

    var cachedAccessibilityData = undefined;
    function addGeoJsonAccessibility(url) {

      if (cachedAccessibilityData != undefined) {
        Map.addGeoJsonAccessibilityObject()
      } else {
        $.getJSON(url, Map.addGeoJsonAccessibilityObject);
      }
    }
    var enableAccessibilityLayer = function (url, property) {

      if (geoJsonLayerGroup) geoJsonLayerGroup.remove();

      Map.property = property;
      addGeoJsonAccessibility(url)
    }

    Map.enableAccessibilityLayer = enableAccessibilityLayer;
    Map.addGeoJsonAccessibilityObject = addGeoJsonAccessibilityObject

    var MAP_CACHE = {};
    var cropBoundsTimeout;

    function addMultiGeoJson(collection) {
      if (markers) {
        markers.clearLayers();
      }

      markers = L.markerClusterGroup();
      bounds = new L.latLngBounds();

      $.each(collection, function (index, item) {

        var url = $(item).data("geojson");
        if (url === undefined || url === "")
          return;

        var handleGeoJson = function (data) {
          var geoJsonLayer = L.geoJSON(data,
              {
                style:
                    {
                      weight: 4,
                      color: "#005692",
                      opacity: 0
                    }
              }).addTo(map);

          geoJsonLayer.visible = false;

          bounds.extend(geoJsonLayer.getBounds());
          tripLayers.push(geoJsonLayer);

          var id = $(item).data("contentid");
          var difficulty = $(item).data("difficulty");

          var marker = new L.marker([data.Start.geometry.coordinates[1], data.Start.geometry.coordinates[0]], { icon: tripIconEasy });

          marker.id = id;
          if (difficulty == "easy") {
            marker.setIcon(tripIconEasy);
          } else if (difficulty == "medium") {
            marker.setIcon(tripIconMedium);
          } else if (difficulty == "difficult") {
            marker.setIcon(tripIconDifficult);
          } else if (difficulty == "extreme") {
            marker.setIcon(tripIconExtreme);
          }

          var name = $(item).find("h3").text();
          marker.bindTooltip(name,
              {
                permanent: false,
                direction: 'right'
              });

          var url = $(item).find('a').attr('href');

          var difficulty = $(item).find('.difficulty').html();
          var length = $(item).find('.length').html();

          marker.bindPopup('' +
              '<strong><a href="' + url + '">' + name + '</a></strong><br />' +
              '<br />' + skTranslate["/routecollectionpage"]["/difficulty"] + ': ' + difficulty +
              ((typeof length !== "undefined") ? "<br />" + skTranslate["/routecollectionpage"]["/length"] + ": " + length : "") +
              '' +
              '<p><a href="' + url + '">' + skTranslate["/routecollectionpage"]["/readmore"] + '</a></p>'
          );

          marker.on('click', function (e) {
            if (geoJsonLayer.visible == false) {

              // Hide all other layers
              $.each(tripLayers, function (index, item) {
                if (item.visible == true) {
                  item.setStyle({ opacity: 0 });
                  item.visible = false;
                }
              })

              geoJsonLayer.setStyle({ opacity: 1 });
              geoJsonLayer.visible = true;
            } else {
              geoJsonLayer.setStyle({ opacity: 0 });
              geoJsonLayer.visible = false;
            }
          });
          markers.addLayer(marker);

          clearTimeout(cropBoundsTimeout);
          cropBoundsTimeout = setTimeout(function () { cropMap() }, 100);
        };

        // Cache hit?
        if (MAP_CACHE[url]) {
          handleGeoJson(MAP_CACHE[url]);
          return;
        }
        // E -> Cold cache.. Warm the cache
        $.getJSON(url, function (data) {
          MAP_CACHE[url] = data;
          handleGeoJson(data);
        });
      });

      map.addLayer(markers);
      map.on('fullscreenchange', function () {
        setTimeout(function () { cropMap() }, 100);
      });

      // Tooltip for cluster.
      markers.on('clustermouseover', function (a) {
        // a.layer = cluster
        a.layer.bindTooltip(a.layer.getAllChildMarkers().length + ' ' + skTranslate["/routecollectionpage"]["/tripsinarea"],
            {
              permanent: false,
              direction: 'right',
              offset: [10, 0]
            }).openTooltip();
      });
      markers.on('clustermouseout', function (a) {
        a.layer.unbindTooltip();
      });

    }
    Map.addMultiGeoJson = addMultiGeoJson;


    var addExtrasObject = function (data) {
    }
    Map.addExtrasObject = addExtrasObject;

    function addExtras(url) {
    }
    Map.addExtras = addExtras;

    function showExtras(ids) {
      commonGeoJsonLayer.eachLayer(function (marker) {

        if (ids !== undefined && ids.includes(marker.friid)) {
          if (marker._icon != undefined) {
            marker._icon.style.display = "block";
          }
          if (marker._shadow != undefined) {
            marker._shadow.style.display = "block";
          }
        } else {
          if (marker._icon != undefined) {
            marker._icon.style.display = "none";
          }
          if (marker._shadow != undefined) {
            marker._shadow.style.display = "none";
          }
        }
      });
    }
    Map.showExtras = showExtras;

    function cropMap() {
      if (bounds !== undefined) {
        map.fitBounds(bounds);
      }
    }

  })(Map = RouteMaps.Map || (RouteMaps.Map = {}));

  var Filter;
  (function (Filter) {

    var length;
    var duration;
    var difficulty;

    function init() {

      $('input[name="difficulty[]"]').on('change', function () {
        var values = new Array();
        $.each($("input[name='difficulty[]']:checked"), function () {
          values.push($(this).val());
        });

        setDifficulty(values.join(","));
        apply();
      });

      $('input[name="duration"]').on('change', function () {
        setDuration($(this).val());
        apply();
      });

      $('input[name="length"]').on('change', function () {
        setLength($(this).val());
        apply();
      });
    }
    Filter.init = init;

    function empty() {

      // Reset inputs
      $("input[name='difficulty[]']").prop("checked", false);
      $("input[name='length']").val($("input[name='length']").attr("max"));
      $("input[name='duration']").val($("input[name='duration']").attr("max"));

      // Reset filter values
      setDifficulty(undefined);
      setLength(undefined);
      setDuration(undefined);

      // Apply
      apply();

      return false;
    }
    Filter.empty = empty;

    function apply() {

      var routesToShow = $(".route-collection-page__list__item").filter(function () {

        // Filter length
        if (length !== undefined
            && length !== ""
            && $(this).data("length") > length) {

          return false;
        }

        // Filter duration
        if (duration !== undefined
            && duration !== ""
            && $(this).data("duration") > duration) {

          return false;
        }

        // Filter difficulty
        if (difficulty !== undefined
            && difficulty !== "") {
          var found = false;
          var filterArr = difficulty.split(",");
          var itemArr = $(this).data("difficulty").split(",");
          $.each(filterArr, function (index, item) {
            if (itemArr.includes(item)) {
              found = true;
            }
          });
          if (!found) return false;
        }

        return true;
      });

      $("h3 span.count").html(routesToShow.length);

      // Scroll to results - for devices smaller than 1024px
      if (((window.innerWidth > 0) ? window.innerWidth : screen.width) < 1024) {
        $('html, body').stop().animate({
          'scrollTop': $('.route-collection-page__map').offset().top
        }, 500, 'swing');
      }

      var allRoutes = $(".route-collection-page__list__item");
      if (allRoutes.length == routesToShow.length) {
        routesToShow.show();
        $(".route-collection-page__list__empty").hide();
      } else {
        allRoutes.fadeOut(100, function () {
          routesToShow.show();
        });

        if (routesToShow.length == 0) {
          $(".route-collection-page__list__empty").fadeIn();
        } else {
          $(".route-collection-page__list__empty").hide();
        }
      }

      $('.route-collection-page__map').addClass('route-collection-page__map--loading');
      $('.route-collection-page__map__loading').addClass('route-collection-page__map__loading--visible');

      clearTimeout(Map.refreshMapTimeout);
      Map.refreshMapTimeout = setTimeout(function () {

        Map.addMultiGeoJson(routesToShow);

        $('.route-collection-page__map').removeClass('route-collection-page__map--loading');
        $('.route-collection-page__map__loading').removeClass('route-collection-page__map__loading--visible');

      }, 0);
    }
    Filter.apply = apply;

    function setLength(val) {
      length = val;
    }
    Filter.setLength = setLength;

    function setDuration(val) {
      duration = val;
    }
    Filter.setDuration = setDuration;

    function setDifficulty(val) {
      difficulty = val;
    }
    Filter.setDifficulty = setDifficulty;

  })(Filter = RouteMaps.Filter || (RouteMaps.Filter = {}));

  // RouteMaps initialization
  function initSingle(url) {

    // Initialize map
    Map.initMap("route-map");

    // Add geoJson if url was set
    if (typeof url === "string" && url.length > 0) {
      Map.addGeoJson(url);
    }

    // Initialize image carousel
    Carousel.initCarousel($(".entity-slider"));
  }
  RouteMaps.initSingle = initSingle;

  function initMulti() {
    // Initialize map
    Map.initMap("routes-map");
    Map.addMultiGeoJson($(".route-collection-page__list__item"));
  }
  RouteMaps.initMulti = initMulti;

}(RouteMaps = RouteMaps || {}));

window.RouteMaps = RouteMaps;

(function ($) {
  $('.route-page__toggle').click(function () {
    var expanded = $(this).hasClass("route-page__toggle--expanded");

    $(this).toggleClass('route-page__toggle--expanded', !expanded);
    $(this).next().toggleClass('route-page__well--expanded', !expanded);
  });

  $('.route-collection-page__toggle').click(function () {
    var expanded = $(this).hasClass("route-collection-page__toggle--expanded");

    $(this).toggleClass('route-collection-page__toggle--expanded', !expanded);
    $(this).next().toggleClass('route-collection-page__well--expanded', !expanded);
  });

  var collapseMobile = function () {
    $('.collapse-mobile').each(function () {
      if ($(this).hasClass('route-collection-page__toggle--expanded') || $(this).hasClass('route-page__toggle--expanded')) {
        $(this).click();
      }
    });
  }
  // Run collapseMobile function for devices smaller than 1024px
  if (((window.innerWidth > 0) ? window.innerWidth : screen.width) < 1024) {
    setTimeout(function () { collapseMobile(); }, 1500);
  }

  if ($(".route-collection-page").length > 0) {
    RouteMaps.initMulti();
    RouteMaps.Filter.init();
    RouteMaps.Sliders.init();
  }

  var $exportPdfLink = $('.js-export-pdf-link');
  var updateExportPdfUrl = function () {

    if ($exportPdfLink.length < 1) {
      console.log('nop')
      return;
    }

    var showInMapParameters = $("input[name='showinmap[]']:checked")
        .map(function () { return this.value; })
        .get();

    var mapBounds = RouteMaps.Map.map.getBounds();

    var pdfParameters = {
      'showInMap': showInMapParameters,
      'neLat': mapBounds._northEast.lat,
      'neLng': mapBounds._northEast.lng,
      'swLat': mapBounds._southWest.lat,
      'swLng': mapBounds._southWest.lng,
      'accessibilityLayer': RouteMaps.Map.property
    };

    var baseUrl = $exportPdfLink.data('base-url');
    var updatedUrl = baseUrl + '?' + $.param(pdfParameters);

    $exportPdfLink.attr('href', updatedUrl);
  }

  RouteMaps.updateExportPdfUrl = updateExportPdfUrl;

  if ($("input[name='showinmap[]']").length > 0) {

    $(function () {
      RouteMaps.Map.map.on('moveend', updateExportPdfUrl);
    });

    $("input[name='showinmap[]']").on("change",
        function () {
          var ids = $("input[name='showinmap[]']:checked").map(function () {
            return this.value;
          }).get();
          RouteMaps.Map.showExtras(ids);

          updateExportPdfUrl();
        });
  }

})(jQuery);